// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"357":"020f2094","852":"d65ff085"}[chunkId] + ".chunk.css";
};